/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BusinessUnitWithRelations } from './businessUnitWithRelations';
import { CompanyWithRelations } from './companyWithRelations';
import { JobPositionWithRelations } from './jobPositionWithRelations';
import { RequisitionCommentWithRelations } from './requisitionCommentWithRelations';
import { HumanCapitalCompanyWithRelations } from './humanCapitalCompanyWithRelations';
import { PersonalRequisitionTypeWithRelations } from './personalRequisitionTypeWithRelations';
import { RequisitionStatusHistoryWithRelations } from './requisitionStatusHistoryWithRelations';
import { UserWithRelations } from './userWithRelations';
import { RequisitionStatusWithRelations } from './requisitionStatusWithRelations';


/**
 * (tsType: PersonalRequisitionWithRelations, schemaOptions: { includeRelations: true })
 */
export interface PersonalRequisitionWithRelations { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: string;
    employeeReplaceName?: string;
    employeeReplaceId?: number;
    salary?: number | null;
    city: string;
    creationReason?: string;
    code?: string;
    followsAuthorizationFlow?: boolean;
    requisitionTypeId?: string;
    jobPositionId?: string;
    currentStatusId?: string;
    immediateSuperiorId?: number;
    areaManagerId?: number;
    generalManagerId?: number;
    financeDirectorId?: number;
    createdByUser?: object;
    humanCapitalCompanyId?: string;
    companyId?: string;
    businessUnitId?: string;
    employeeReplace?: UserWithRelations;
    requisitionType?: PersonalRequisitionTypeWithRelations;
    jobPosition?: JobPositionWithRelations;
    currentStatus?: RequisitionStatusWithRelations;
    immediateSuperior?: UserWithRelations;
    areaManager?: UserWithRelations;
    generalManager?: UserWithRelations;
    financeDirector?: UserWithRelations;
    requisitionComments?: Array<RequisitionCommentWithRelations>;
    requisitionStatusHistories?: Array<RequisitionStatusHistoryWithRelations>;
    humanCapitalCompany?: HumanCapitalCompanyWithRelations;
    company?: CompanyWithRelations;
    businessUnit?: BusinessUnitWithRelations;
}

